import loadable from '@loadable/component';

const LoadableEmblaCarousel = loadable(
  () => import(/* webpackChunkName: "embla-carousel" */ './index'),
  { ssr: false }
);

export default LoadableEmblaCarousel;
